"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CATEGORY_PAGE_SKELETON = void 0;
const CATEGORY_PAGE_SKELETON = exports.CATEGORY_PAGE_SKELETON = 'category-page-skeleton';
